import { post } from '@/utils/request'

/**
 * 淘客获取自己没用过的新权限标记"已用"
 * @param {Object} data
 * @param {string} data.module  模块(暂定约定模块名 用功能的相对路径来定义，如： /cms-website/decoration)
 */
export default function taoke_module_new_mark(data) {
  return post('taoke_module_new_mark', data)
}